import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  token: '',
  menuCollapsed: null,
  dynRoutes: [],
  username: '',
  userId: '',
  asId: ''
}

const getters = {
  getToken () {
    let t = state.token
    if (!t) {
      t = sessionStorage.getItem('token') || ''
      if (t) {
        state.token = t
      }
    }
    return t
  },
  getMenuCollapsed () {
    let t = state.menuCollapsed
    if (t === null) {
      t = sessionStorage.getItem('menu_collapsed')
      t = Boolean(t).valueOf()
      if (t) {
        state.menuCollapsed = true
      }
    }
    return t
  },
  getUsername () {
    let u = state.username
    if (!u) {
      u = sessionStorage.getItem('username') || ''
      if (u) {
        state.username = u
      }
    }
    return u
  },
  getUserId () {
    let u = state.userId
    if (!u) {
      u = sessionStorage.getItem('userId') || ''
      if (u) {
        state.userId = u
      }
    }
    return u
  },
  getAsId () {
    let u = state.asId
    if (!u) {
      u = sessionStorage.getItem('asId') || ''
      if (u) {
        state.asId = u
      }
    }
    return u
  }
}

const mutations = {
  setToken (state, token) {
    state.token = token
    if (token) {
      sessionStorage.setItem('token', token)
    } else {
      sessionStorage.removeItem('token')
    }
  },
  setMenuCollapse (state, mc) {
    state.menuCollapsed = mc
    sessionStorage.setItem('menu_collapsed', '' + mc)
  },
  setUsername (state, username) {
    state.username = username
    if (username) {
      sessionStorage.setItem('username', username)
    } else {
      sessionStorage.removeItem('username')
    }
  },
  setUserId (state, userId) {
    state.userId = userId
    if (userId) {
      sessionStorage.setItem('userId', userId)
    } else {
      sessionStorage.removeItem('userId')
    }
  },
  setAsId (state, asId) {
    state.asId = asId
    if (asId) {
      sessionStorage.setItem('asId', asId)
    } else {
      sessionStorage.removeItem('asId')
    }
  }
}

const actions = {
  changeToken (context, token) {
    context.commit('setToken', token)
  },
  menuCollapse (context, mc) {
    context.commit('setMenuCollapse', mc)
  },
  username (context, username) {
    context.commit('setUsername', username)
  },
  userId (context, userId) {
    context.commit('setUserId',userId)
  },
  asId (context, asId) {
    context.commit('setAsId',asId)
  }
}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store/index.js